import '@/assets/main.scss';
import '@fortawesome/fontawesome-free/css/all.css';

import {createApp} from 'vue';
import App from './App.vue';
import router from '@/router'
import VueMatomo from 'vue-matomo'

import axios from 'axios'

axios.defaults.baseURL = import.meta.env.VITE_API_URL

createApp(App)
  .use(VueMatomo, {
    host: 'https://pretapartir.matomo.cloud/',
    siteId: 10,
    trackerFileName: 'matomo',
    enableLinkTracking: true,
    trackInitialView: true,
    router: router,
    debug: false,
  })
  .use(router)
  .mount('#app');
